import { render, staticRenderFns } from "./ProjectJournals.vue?vue&type=template&id=2e05e7db&scoped=true&"
import script from "./ProjectJournals.vue?vue&type=script&lang=ts&"
export * from "./ProjectJournals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e05e7db",
  null
  
)

export default component.exports